export const SUBSCRIPTION_ACTIVE_STATUSES = [
  "subscription_canceled",
  "subscription_expired",
  "subscription_past_due",
  "subscription_suspended",
  "subscription_reactivated",
  "subscription_created",
  "subscription_activated",
  "trial_started",
  "trial_ending",
  "trial_ended",
] as const;

/** Continuam no enum da API para não invalidar integrações já salvas, mas não publicam webhook. */
export const UNPUBLISHED_SUBSCRIPTION_STATUSES = [
  "subscription_card_expired",
  "subscription_awaiting_payment",
] as const;

export function withoutUnpublishedSubscriptionStatuses(
  statuses: string[] | undefined | null,
): string[] {
  if (!statuses) {
    return [];
  }

  return statuses.filter(
    (status) =>
      !(UNPUBLISHED_SUBSCRIPTION_STATUSES as readonly string[]).includes(status),
  );
}

export const SUBSCRIPTION_TEST_PAYMENT_METHODS = [
  "credit_card",
  "bank_slip",
] as const;

export type SubscriptionActiveStatus = (typeof SUBSCRIPTION_ACTIVE_STATUSES)[number];

export function isSubscriptionActiveStatus(status: string): boolean {
  return (SUBSCRIPTION_ACTIVE_STATUSES as readonly string[]).includes(status);
}

export function filterPaymentMethodsForSubscriptionTest(
  availableMethods: string[],
): string[] {
  const allowed = new Set<string>(SUBSCRIPTION_TEST_PAYMENT_METHODS);

  return availableMethods.filter((method) => allowed.has(method));
}
